import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { TicketTemplateSettings } from '../../components/TicketTemplateSettings';

export function TicketSettings() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="sticky top-0 bg-white dark:bg-gray-800 border-b dark:border-gray-700">
        <div className="flex items-center p-4">
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate('/settings')}
              className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
            >
              <ArrowLeft className="w-5 h-5 dark:text-gray-200" />
            </button>
            <h1 className="text-2xl font-bold dark:text-white">Configuración de Tickets</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <TicketTemplateSettings />
      </div>
    </div>
  );
} 